import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from "react-router-dom";
import CustomContentItem from '../../../../shared/react/components/custom-content-item.jsx';
import FilterableGrid from '../../../../shared/react/components/filterable-grid.jsx';
import { postGetTranslations } from '../../../../shared/apis/translations';
import Cookies from 'js-cookie';

const DashboardModules = (props) => {
    const [modules, setModules] = useState([]);
    const [order, setOrder] = useState({
        order1: "",
        order2: "",
        order3: "",
        order4: "",
    });
    const [isLoading, setIsLoading] = useState(true);
    const [translationLookup, setTranslationLookup] = useState({});
    const translationKeys = {
        WelcomeTxt: 'Dashboard.Label.WelcomeTxt',
        WelcomeTitleTxt: 'Dashboard.Label.WelcomeTitleTxt',
        CustomizeDashboardBtn: 'Dashboard.label.CustomizeDashboardBtn',
        NoInfoTxt: 'Dashboard.Label.NoInfoTxt',
        CheckBackSoon: 'Site.CheckBackSoon'
    };

    useEffect(() => {
        postGetTranslations(Object.values(translationKeys))
            .then((translations) => {
                setTranslationLookup({
                    WelcomeTxt: translations[translationKeys.WelcomeTxt] ?? 'Welcome',
                    WelcomeTitleTxt: translations[translationKeys.WelcomeTitleTxt] ?? 'Welcome to Portal',
                    CustomizeDashboardBtn: translations[translationKeys.CustomizeDashboardBtn] ?? 'Button Text',
                    NoInfoTxt: translations[translationKeys.NoInfoTxt] ?? 'No Info',
                    FilterSearchMessage: translations[translationKeys.FilterSearchMessage] ?? 'Filter your search below...',
                    CheckBackSoon: translations[translationKeys.CheckBackSoon] ?? 'Please check back soon...'
                });
            })
            .catch((error) => {
                console.error('Error fetching translations:', error);
            });
    }, []);


    useEffect(() => {
        if (props.contact && props.contact.Email) {
            const params = { email: props.contact.Email };

            Promise.all([
                props.getQuizzesForContact(params),
                props.getEventsForContact(params)
            ]).then(() => {
                setModules(props.modules);
                if (props.modules && props.modules.length) {
                    setOrder({
                        order1: props.modules[0].NodeId,
                        order2: props.modules[1].NodeId,
                        order3: props.modules[2].NodeId,
                        order4: props.modules[3].NodeId,
                    });
                }
                setIsLoading(false);
            }).catch(error => {
                console.error("Failed to fetch data:", error);
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }, [props.contact, props.modules]);

    const gravatarImg = "/img/generic-avatar.png";
    const navigate = useNavigate();

    const getFilterableGridHeading = (heading, headingType) => {
        switch (headingType) {
            case "default":
                return (<h2 className="heading">{heading}</h2>);
            case "section":
                return (
                    <div className="section-header">
                        <h2 className="section-title"><span>{heading}</span></h2>
                    </div>
                );
            case "centered":
                return (
                    <div className="row justify-content-center">
                        <h2 className="heading">{heading}</h2>
                    </div>
                );
            case "right":
                return (
                    <div className="row justify-content-end">
                        <h2 className="heading">{heading}</h2>
                    </div>
                );
            default:
                return null;
        }
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    const firstName = props.contact ? (props.contact.FirstName || props.contact.firstName) : "Name";
    const lastName = props.contact ? (props.contact.LastName || props.contact.lastName) : "Last Name";
    const title = props.contact ? (props.contact.Title || props.contact.title) : "Title";
    const company = props.contact ? (props.contact.Company || props.contact.company) : "Company";

    if (!props.contact) {
        return <div>{translationLookup.NoInfoTxt}</div>;
    }

    return (
        <>
            <div className="section container">
                <h2 className="intro-blk-copy"> {translationLookup.WelcomeTitleTxt}</h2>
            </div>

            <div className="section container">
                {props.filterableGrid.heading ? getFilterableGridHeading(props.filterableGrid.heading, props.filterableGrid.headingType) : null}
                {props.filterableGrid.api && (!props.filterableGrid.hideGrid ? (
                    <FilterableGrid {...props.filterableGrid} />
                ) : (
                    <div className="row justify-content-center">
                        <h3 className="section-title">{translationLookup.CheckBackSoon}</h3>
                    </div>
                ))}
            </div>
        </>
    );
}

export default DashboardModules;
